import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/inherits";
import { ItemList, Panel, CheckboxItemList } from '../../../ui';
import { FacetFilter } from "./FacetFilter";

var defaults = require("lodash/defaults");

var concat = require("lodash/concat");

var isUndefined = require("lodash/isUndefined");

import { FacetFilterPropTypes } from "./FacetFilterProps";
export { Panel, CheckboxItemList };
var allItem = {
  key: "$all",
  label: "All"
};
export var MenuFilter =
/*#__PURE__*/
function (_FacetFilter) {
  _inherits(MenuFilter, _FacetFilter);

  function MenuFilter() {
    _classCallCheck(this, MenuFilter);

    return _possibleConstructorReturn(this, _getPrototypeOf(MenuFilter).apply(this, arguments));
  }

  _createClass(MenuFilter, [{
    key: "toggleFilter",
    value: function toggleFilter(option) {
      if (option === allItem.key || this.accessor.state.contains(option)) {
        this.accessor.state = this.accessor.state.clear();
      } else {
        this.accessor.state = this.accessor.state.setValue([option]);
      }

      this.searchkit.performSearch();
    }
  }, {
    key: "setFilters",
    value: function setFilters(options) {
      this.toggleFilter(options[0]);
    }
  }, {
    key: "getSelectedItems",
    value: function getSelectedItems() {
      var selectedValue = this.accessor.state.getValue()[0];
      return [!isUndefined(selectedValue) ? selectedValue : allItem.key];
    }
  }, {
    key: "getItems",
    value: function getItems() {
      var all = {
        key: allItem.key,
        label: allItem.label,
        doc_count: this.accessor.getDocCount()
      };
      return concat([all], _get(_getPrototypeOf(MenuFilter.prototype), "getItems", this).call(this));
    }
  }]);

  return MenuFilter;
}(FacetFilter);
MenuFilter.propTypes = defaults({}, FacetFilterPropTypes.propTypes);
MenuFilter.defaultProps = defaults({
  listComponent: ItemList,
  operator: "OR"
}, FacetFilter.defaultProps);